/* src/app/warehousing/pages/product-classes-edit/product-classes-edit.component.scss */
/*# sourceMappingURL=product-classes-edit.component.css.map */
